export default "data:image/gif;base64,R0lGODlhEgAMAPEBAAAAi/////8AAOXl5SH5BAAAAAAALAAAAAASAAwAAAIlhD+pwn0XomzuATmpsBcHvVnep3EjaHqoqJYstj6nK7cUpyxaAQA7"